import React, { useContext, useRef, useState } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import {
    invoicesIssuedContainerStyle,
    invoicesIssuedTableStyle,
    invoicesIssuedHeadCellStyle,
    invoicesIssuedTextStyle,
    invoicesIssuedMainCellStyle,
    invoiceNumberTextStyle,
    standardScrollbarStyle
} from './BillingStyles';
import {
    Spacer,
    ScrollableArea,
    ScrollbarSvg
} from '@adserve/adserve-react-components';
import moment from 'moment';

const BillingInvoicesIssued = ({
    tableData = [],
    invoicesAirtime,
    invoicesOffairs,
    invoicesCommission,
    invoicesVat,
    invoicesTotal,
    setShowInvoiceDetails,
    setInvoiceDetails
}) => {
    const { formatCurrency, dateFormat } = useContext(SystemSettingsContext);
    const invoicesScrollRef = useRef(null);
    const [invoicesScrollPx, setInvoicesScrollPx] = useState(0);

    const handleScroll = (val) => {
        setInvoicesScrollPx(val);
        invoicesScrollRef?.current?.scroll(0, val);
    };

    const handleCellClick = (type = 'invoice', payload) => {
        // xxx
        setInvoiceDetails(payload);
        setShowInvoiceDetails(true);
    };
    return (
        <div style={invoicesIssuedContainerStyle}>
            <div style={{ marginLeft: 8, paddingTop: 13, paddingBottom: 8 }}>
                <div
                    style={{
                        position: 'absolute',
                        marginTop: 8,
                        marginLeft: -8,
                        height: 1,
                        width: 1791,
                        backgroundColor: '#D7D7D7'
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        marginTop: 49,
                        marginLeft: -8,
                        height: 1,
                        width: 1791,
                        backgroundColor: '#D7D7D7'
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        marginTop: 48,
                        marginLeft: -8,
                        height: 1,
                        width: 1791,
                        backgroundColor: 'white'
                    }}
                />
            </div>
            <ScrollableArea
                id={'invoices-issued-container'}
                ref={invoicesScrollRef}
                style={{ width: '100%' }}
                height={287}
                scrollSpeed={8}
                scrollPx={invoicesScrollPx}
                onScroll={setInvoicesScrollPx}
                scrollableLength={invoicesScrollRef?.current?.scrollHeight}
                maxVisibleLength={invoicesScrollRef?.current?.clientHeight}
            >
                <table style={invoicesIssuedTableStyle}>
                    <thead>
                        <tr>
                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 170
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Invoice Number')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 143
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Invoice Start Date')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Invoice End Date')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 197
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Purchase Order Number')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 150
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Airtime')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 150
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Off-Airs')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Commission')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 155
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('VAT')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 156
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Total')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 145
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Issue Date')}
                                </span>
                            </th>

                            <th
                                style={{
                                    ...invoicesIssuedHeadCellStyle,
                                    width: 225
                                }}
                            >
                                <span style={invoicesIssuedTextStyle}>
                                    {window.translate('Authorised By')}
                                </span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableData?.map((dp, i) => (
                            <tr key={`invoices-issued-${i}`}>
                                <td
                                    align='right'
                                    style={{
                                        ...invoicesIssuedMainCellStyle(
                                            i,
                                            dp?.type === 'Credit'
                                        ),
                                        cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                        handleCellClick('invoice', dp)
                                    }
                                >
                                    <span
                                        style={invoiceNumberTextStyle(
                                            dp?.type === 'Credit'
                                        )}
                                    >
                                        {dp?.invoiceNumber}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {moment(dp?.periodStartDate).format(
                                            dateFormat
                                        )}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {moment(dp?.periodEndDate).format(
                                            dateFormat
                                        )}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {dp?.poNumber}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {formatCurrency(dp?.netAirtimeValue)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {formatCurrency(dp?.netOffAirsValue)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {formatCurrency(dp?.commission)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {formatCurrency(dp?.totalVat)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {formatCurrency(dp?.total)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {new Date(dp?.invoiceDate)
                                            .toDateString()
                                            .substring(4)}
                                    </span>
                                </td>
                                <td
                                    align='right'
                                    style={invoicesIssuedMainCellStyle(
                                        i,
                                        dp?.type === 'Credit'
                                    )}
                                >
                                    <span style={invoicesIssuedTextStyle}>
                                        {dp?.name}
                                    </span>
                                </td>
                            </tr>
                        ))}
                        {Object.keys(tableData)?.length < 7
                            ? Array.apply(
                                null,
                                Array(7 - Object.keys(tableData)?.length)
                            )
                                .map(function () {
                                    return {};
                                })
                                .map((dp, j) => (
                                    <tr
                                        key={`invoices-issued-padding-row-${j}`}
                                    >
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                        <td
                                            align='right'
                                            style={invoicesIssuedMainCellStyle(
                                                j
                                            )}
                                        ></td>
                                    </tr>
                                ))
                            : null}
                    </tbody>
                </table>
            </ScrollableArea>
            <div style={standardScrollbarStyle}>
                {tableData?.length > 7 && (
                    <ScrollbarSvg
                        scrollPx={invoicesScrollPx}
                        onScroll={handleScroll}
                        maxVisibleLength={244}
                        gutterOffset={400}
                        scrollableLength={
                            invoicesScrollRef?.current?.scrollHeight
                        }
                        disabled={false}
                    />
                )}
            </div>
            <div
                style={{
                    display: 'flex',
                    flexBasis: 1,
                    width: 1857,
                    marginTop: -1
                }}
            >
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 169,
                        paddingTop: 10
                    }}
                >
                    Total invoiced
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 144,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 155,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 197,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 150,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(invoicesAirtime) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 150,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(invoicesOffairs) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 155,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(invoicesCommission) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 155,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(invoicesVat) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 11,
                        width: 156,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                >
                    {formatCurrency(invoicesTotal) || '£0.00'}
                </div>
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 29,
                        width: 145,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
                <div
                    align='right'
                    style={{
                        ...invoicesIssuedMainCellStyle(1),
                        paddingRight: 29,
                        width: 225,
                        marginLeft: -1,
                        paddingTop: 10
                    }}
                />
            </div>
            <Spacer height={25} width={0} />
        </div>
    );
};

export default BillingInvoicesIssued;
